import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Tabs, Tab } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import { TaskCheckList } from './TaskCheckList';
import TaskDescription from './TaskDescription';
import TaskDocuments from './TaskDocuments';
import { DocumentStore } from 'src/store/DocumentStore';
import TaskDetailList from './TaskDetailList';
import TaskDocumentation from './TaskDocumentation';
import TaskNotes from './TaskNotes';
import BoardyDialog from '../../components/BoardyDialog';
import TaskPercentage from './TaskPercentage';
import TaskTimeItemCalendar from './TaskTimeItemCalendar';
import 'src/css/tabs.css';
import { Events } from 'src/services/Events';
import GitBranchButton from 'src/components/GitBranchButton';
import TaskRating from './TaskRating';
import TaskHistory from './TaskHistory';
var styles = {
    body: {
        padding: 0,
        color: '#222',
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    tabButton: {
        height: '40px',
        lineHeight: '40px',
        fontSize: '13px',
        flexDirection: 'row'
    },
    tabInk: {
        backgroundColor: '#fff'
    },
    gitIconContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'end'
    }
};
var TaskDetail = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDetail, _super);
    function TaskDetail(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePercentageChange = function (e) {
            e.preventDefault();
            _this.props.task.setPercentage(e.target.value);
        };
        _this.handleTaskRatingChange = function (rating) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.props.task.setRating(rating)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleClosing = function () {
            var args = {
                confirmed: false
            };
            Events.taskDialogClosed._fire(args);
            if (args.confirmed) {
                _this.props.onClose();
            }
        };
        return _this;
    }
    TaskDetail.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, task = _a.task, featuresStore = _a.featuresStore, userStore = _a.userStore;
        var checkList = !task.hasCheckList
            ? null
            : (React.createElement(Tab, { label: "TEEND\u0150K", icon: React.createElement(FontIcon, { className: "material-icons" }, "check_box"), buttonStyle: styles.tabButton },
                React.createElement(TaskCheckList, { isReadonly: task.isReadonly, items: task.checkListItems })));
        var titleContent = !featuresStore.features.gitlabIntegration ? null : (React.createElement("div", { style: styles.gitIconContainer },
            React.createElement(GitBranchButton, { task: task, userStore: userStore })));
        return (React.createElement(BoardyDialog, { open: isOpen, onClosing: this.handleClosing, title: task.stepName + " " + task.title, titleContent: titleContent },
            React.createElement("div", { style: { overflowX: 'hidden' } },
                React.createElement(Tabs, { inkBarStyle: styles.tabInk, className: "task-tab" },
                    React.createElement(Tab, { label: "LE\u00CDR\u00C1S", buttonStyle: styles.tabButton },
                        React.createElement(TaskDescription, { html: task.description })),
                    (!task.partnerNote ? null : React.createElement(Tab, { label: "PARTNERI LE\u00CDR\u00C1S", buttonStyle: styles.tabButton },
                        React.createElement(TaskDescription, { html: task.partnerNote }))),
                    React.createElement(Tab, { label: "ADATOK", buttonStyle: styles.tabButton },
                        React.createElement(TaskDetailList, { task: task })),
                    React.createElement(Tab, { label: "R\u00C1FORD\u00CDT\u00C1S", buttonStyle: styles.tabButton },
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', flexDirection: 'row', margin: '1rem' } },
                                React.createElement(TaskPercentage, { task: task }),
                                React.createElement(TaskRating, { max: 5, value: task.rating, onChange: this.handleTaskRatingChange })),
                            React.createElement(TaskTimeItemCalendar, { task: task }))),
                    React.createElement(Tab, { label: "T\u00D6RT\u00C9NET", buttonStyle: styles.tabButton },
                        React.createElement(TaskHistory, { taskID: task.id })),
                    checkList,
                    React.createElement(Tab, { label: "CSATOLM\u00C1NYOK", buttonStyle: styles.tabButton },
                        React.createElement(TaskDocuments, { store: new DocumentStore(task) })),
                    !featuresStore.features.developerDocumentation ? null : (React.createElement(Tab, { label: "DOKUMENT\u00C1CI\u00D3", buttonStyle: styles.tabButton },
                        React.createElement(TaskDocumentation, { task: task }))),
                    React.createElement(Tab, { label: "MEGJEGYZ\u00C9SEK", buttonStyle: styles.tabButton },
                        React.createElement(TaskNotes, { task: task }))))));
    };
    TaskDetail = tslib_1.__decorate([
        inject('featuresStore', 'userStore'),
        observer
    ], TaskDetail);
    return TaskDetail;
}(React.Component));
export { TaskDetail };



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDetail.tsx
// module id = 295
// module chunks = 0